/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_ed283dfc"]'><cube-button icon="like" inline primary>With-Icon 按钮</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_ed283dfc"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_ed283dfc"}
  /** script content **/
  require("./btn-inline-icon.mpx.js?isComponent&outputPath=components%2Fbtn-inline-iconed283dfc%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-inline-icon.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-inline-iconed283dfc%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_ed283dfc"],
    ctorType: "component",
    outputPath: "components/btn-inline-iconed283dfc/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>